<!-- Top bar: breadcrumb back-link, mirroring the view-invoice drill-in. -->
<vb-breadcrumb
    [trail]="crumbTrail"
    (back)="goBack()"
    (crumbSelect)="onCrumbSelect($event)">
</vb-breadcrumb>

<vb-panel-header
    class="pay-panel__header"
    title="Payments"
    [subtitle]="invoiceNumber ? 'Invoice #' + invoiceNumber : undefined">
</vb-panel-header>

<vb-payment-table
    *ngIf="!isLoading && rows.length > 0"
    class="pay-panel__table"
    [rows]="rows">
</vb-payment-table>

<div *ngIf="!isLoading && rows.length === 0" class="pay-panel__empty">
    No data to show at the moment.
</div>

<div *ngIf="isLoading" class="vb-spinner-box vb-spinner-box--panel">
    <vb-spinner size="xl" label="Loading payments"></vb-spinner>
</div>
